import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest} from 'redux-saga/effects'
import { UserModel } from '../../../models'

import {getUserByToken} from './AuthCRUD'

export interface ActionWithPayload<T> extends Action {
    payload?: T
}

export const actionTypes = {
    Login: '[Login] Action',
    Logout: '[Logout] Action',
    UserRequested: '[Request User] Action',
    UserLoaded: '[Load User] Auth API',
    SetUser: '[Set User] Action',
}

const initialAuthState: IAuthState = {
    user: undefined,
    access_token: undefined,
    expires_at: undefined,
    event_code: undefined,
    nm_event: undefined
}

export interface IAuthState {
    user?: UserModel
    access_token?: string
    expires_at?: string
    event_code?: string
    nm_event?: string
}

export const reducer = persistReducer(
    {
        storage,
        key: 'v100-demo1-auth',
        whitelist: ['user', 'access_token', 'expires_at', 'privilege', 'event_code', 'nm_event'],
    },
    (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
        switch (action.type) {
            case actionTypes.Login: {
                const access_token = action.payload?.access_token
                const expires_at = action.payload?.expires_at
                const event_code = action.payload?.event_code
                const nm_event = action.payload?.nm_event
                return {
                    access_token,
                    expires_at,
                    user: undefined,
                    privilege: undefined,
                    event_code,
                    nm_event,
                }
            }

            case actionTypes.Logout: {
                return initialAuthState
            }

            case actionTypes.UserRequested: {
                return {...state, user: undefined, privilege: undefined}
            }

            case actionTypes.UserLoaded: {
                const user = action.payload?.user
                return {...state, user}
            }

            case actionTypes.SetUser: {
                const user = action.payload?.user
                return {...state, user}
            }

            default:
                return state
        }
    }
)

export const actions = {
    login: (access_token: string, expires_at: Date, event_code: string, nm_event: string) => ({
        type: actionTypes.Login,
        payload: {access_token, expires_at, event_code, nm_event},
    }),
    logout: () => ({type: actionTypes.Logout}),
    requestUser: () => ({
        type: actionTypes.UserRequested,
    }),
    fulfillUser: (user: UserModel) => ({
        type: actionTypes.UserLoaded,
        payload: {user},
    }),
    setUser: (user?: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
}

export function* saga() {
    yield takeLatest(actionTypes.Login, function* loginSaga() {
        yield put(actions.requestUser())
    })

    yield takeLatest(actionTypes.UserRequested, function* userRequested() {
        const {data: user} = yield getUserByToken()
        yield put(actions.fulfillUser(user.data.user))
    })
}
